import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { MessagingResponse } from '../models/messaging.models';
import { environment } from '@env/environment';
import { DocumentType } from '@shared/services/tenant-url-util.service';

export interface GetMessagesParams {
  tenant: string;
  documentType: DocumentType;
  documentValue: string;
  dateRange?: { dateFrom: string; dateTo: string } | null;
  email?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  private readonly http = inject(HttpClient);
  private readonly baseEndpoint = `${environment.API_MESSAGING}/api/customer-care/v2`;

  async getMessages(params: GetMessagesParams): Promise<MessagingResponse> {
    const url = `${this.baseEndpoint}/${params.tenant.toLowerCase()}/messaging/messages`;

    let httpParams = new HttpParams();

    switch (params.documentType) {
      case 'EMAIL':
        httpParams = httpParams.set('email', params.documentValue);
        break;
      case 'IDENTITY_DOCUMENT':
        if (params.email) {
          httpParams = httpParams.set('email', params.email);
        }
        break;
      case 'ORDER_ID':
      case 'SALE_NOTE_NUMBER':
        httpParams = httpParams.set('order-id', params.documentValue);
        break;
      default:
        throw new Error(`Unsupported document type: ${params.documentType}`);
    }

    if (params.dateRange) {
      httpParams = httpParams
        .set('date-from', params.dateRange.dateFrom)
        .set('date-to', params.dateRange.dateTo);
    }

    httpParams = httpParams.set('limit', 200);
    httpParams = httpParams.set('offset', 0);

    return firstValueFrom(
      this.http.get<MessagingResponse>(url, { params: httpParams })
    );
  }
}